import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export const VEHICLE_SNAPSHOT_SUBJECT = "VehicleSnapshot" as const;

export function setVehicleSnapshotPermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.FabVehicleValuationAdministrator)) {
    can(Action.Read, VEHICLE_SNAPSHOT_SUBJECT);
  }
}
